<template>
  <div class="report-wrapper">
    <table class="table report-preview">
      <template v-for="year in report">
        <tr>
          <th v-for="(column, thIndex) in headers" :key="'header-column-' + thIndex">{{column.title}}</th>
        </tr>
        <tr v-for="(row, rowIndex) in year" :key="'row-' + year + rowIndex">
          <td
            v-for="(col, tdIndex) in headers"
            :class="col.class || ''"
            :key="'row-' + rowIndex + '-column-' + tdIndex"
            :title="modify(col.callback, row[col.name])"
          >{{modify(col.callback, row[col.name])}}</td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
export default {
  name: 'reportPreview',
  data() {
    return {
      //
    }
  },
  props: {
    report: {
      type: Object,
      default: () => {},
    },
    headers: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    modify(callback, val) {
      return typeof callback === 'function' ? callback(val) : val
    },
  },
}
</script>
<style scoped>
.report-wrapper {
  overflow: auto;
  width: 100%;
}
.report-preview td {
  padding: 0px 10px;
  border-bottom: solid 1px #e6e6e6;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.report-preview td.croped {
  max-width: 300px;
}
.report-preview th {
  padding: 4px 10px;
}
</style>
